import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import Videos from './pages/Videos';
import Stories from './pages/Stories';
import Contacts from './pages/Contacts';
import Categories from './pages/Categories';
import Notifications from './pages/Notifications';
import Admins from './pages/Admins';
import Settings from './pages/Settings';
import Layout from './components/Layout';
import theme from './theme/theme';
import './utils/i18n';

const PrivateRoute = ({ children }) => {
  const { admin, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return admin ? children : <Navigate to="/login" />;
};

const SuperAdminRoute = ({ children }) => {
  const { admin, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!admin) {
    return <Navigate to="/login" />;
  }

  if (admin.role !== 'superadmin') {
    return <Navigate to="/" />;
  }

  return children;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="customers" element={<Customers />} />
              <Route path="videos" element={<Videos />} />
              <Route path="stories" element={<Stories />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="categories" element={<Categories />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="settings" element={<Settings />} />
              <Route path="admins" element={<SuperAdminRoute><Admins /></SuperAdminRoute>} />
            </Route>
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;